import moment from "moment";

import {APP} from "../../../constants/appUrls.constants";
import {getProperty, isDefined} from "../../../utils";

/**
 * Bildirim canı yalnizca bir tesis baglaminda anlamlidir.
 *
 *  - Tesis secilmemisse (ilk giriste /app'te property_id henuz yazilmamis olur)
 *    yoklama yapilmaz; aksi halde servise bos {"params":{}} govdesi gider.
 *  - Tesis secim ekraninin (/app) kendisinde de baglam yok: kullanici zaten
 *    hangi otelle calisacagini seciyor.
 *
 * Hem poller hem can ayni kurali kullanir; ikisi ayrisirsa olu bir can kalir.
 */
export const isBookingNotificationEnabled = (pathname) => {
    if (!isDefined(getProperty())) return false;
    if (pathname === APP) return false;
    return true;
};

/**
 * Rezervasyon durumu -> renk tonu + ceviri anahtari.
 * Esleme ReservationDetail/components/Detail.js ile ayni tutuldu.
 */
export const resolveBookingStatus = (status, t) => {
    switch (Number(status)) {
        case 0:
            return {tone: 'danger', label: t('enw-payment_transaction-status-cancel_refund')};
        case 1:
            return {tone: 'success', label: t('enw-channels-channel_setup-booking-title')};
        case 2:
            return {tone: 'info', label: t('enw-reservation-prebooking')};
        case 3:
            return {tone: 'danger', label: t('enw-reservation-no-show')};
        default:
            return null;
    }
};

// "Suzanne Ferrell" -> "SF"; isim yoksa noturr bir isaret.
export const getGuestInitials = (fullName) => {
    if (!fullName) return '—';
    const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '—';
    return parts
        .slice(0, 2)
        .map(part => part.charAt(0).toLocaleUpperCase('tr'))
        .join('');
};

export const formatShortDate = (value) => {
    if (!value) return null;
    const date = moment(value);
    return date.isValid() ? date.format('DD.MM.YYYY') : null;
};

export const countNights = (checkin, checkout) => {
    if (!checkin || !checkout) return 0;
    const start = moment(checkin);
    const end = moment(checkout);
    if (!start.isValid() || !end.isValid()) return 0;
    const diff = end.diff(start, 'days');
    return diff > 0 ? diff : 0;
};

/**
 * 1234.5 -> "1.234,5" (aktif dile gore). Intl yoksa ham degere duser.
 */
export const formatAmount = (total, language) => {
    if (total === null || total === undefined || total === '') return null;
    const amount = Number(total);
    if (isNaN(amount)) return String(total);
    try {
        return new Intl.NumberFormat(language || 'tr-TR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(amount);
    } catch (e) {
        return String(total);
    }
};

// Rozet metni: 9'dan buyukse "9+".
export const formatBadgeCount = (count, max) => {
    const value = Number(count) || 0;
    if (value <= 0) return null;
    return value > max ? `${max}+` : String(value);
};
